module.exports = __webpack_public_path__ + "img/cart-icon.2557f00f.svg";